export default class FormacaoService {
    constructor($q, UIService, AuthenticationService, FormacaoTestemunho, FormacaoAreaInteresse, FormacaoCurso, FormacaoEdicao) {
        this.$q = $q;
        this.UI = UIService;
        this.Auth = AuthenticationService;
        this.FormacaoTestemunho = FormacaoTestemunho;
        this.FormacaoAreaInteresse = FormacaoAreaInteresse;
        this.FormacaoCurso = FormacaoCurso;
        this.FormacaoEdicao = FormacaoEdicao;
    }
    removeTestemunhos = (ids) => {
        let defer = this.$q.defer();
        if (!ids || ids.length === 0)
            defer.reject();
        this.FormacaoTestemunho.find({
            filter: {
                where: {
                    and: [{ id: { inq: ids } }, { active: 1 }]
                }
            }
        }).$promise.then((testemunhos) => {
            let status = [];
            let tasks = [];
            if (ids.length === testemunhos.length) { // Things look ok to delete
                testemunhos.forEach(t => {
                    let deferDelete = this.$q.defer();
                    t.criadoPorId = this.Auth.getId();
                    t.visivel = 0;
                    t.active = 0;
                    t.dataCriacao = moment().format();
                    this.FormacaoTestemunho.upsert(t).$promise.then((res) => {
                        status.push({
                            error: false,
                            testemunhoId: t.id
                        });
                        deferDelete.resolve(t.id);
                    }).catch((error) => {
                        console.log(error);
                        status.push({
                            error: true,
                            testemunhoId: t.id,
                            message: `Erro na eliminação de testemunho ${t.id}`
                        });
                        deferDelete.resolve(t.id);
                    });
                    tasks.push(deferDelete.promise);
                });
                this.$q.all(tasks).then((res) => {
                    defer.resolve(status);
                }).catch(error => {
                    defer.reject(error);
                });
            }
            else { // Return error saying not all was found
                status.push({
                    error: true,
                    message: 'Não foi possível encontrar todos os testemunhos para eliminar. Recarregue a página e verifique se ainda existem.'
                });
                defer.resolve(status);
            }
        }).catch((error) => {
            defer.reject(error);
        });
        return defer.promise;
    };
    removeAreasInteresse = (ids) => {
        let defer = this.$q.defer();
        if (!ids || ids.length === 0)
            defer.reject();
        this.FormacaoAreaInteresse.find({
            filter: {
                where: {
                    and: [{ id: { inq: ids } }, { active: 1 }]
                }
            }
        }).$promise.then((areas) => {
            let status = [];
            let tasks = [];
            if (ids.length === areas.length) { // Things look ok to delete
                areas.forEach(a => {
                    let deferDelete = this.$q.defer();
                    this.FormacaoCurso.find({
                        filter: {
                            where: {
                                and: [{ active: 1 }, { areaInteresseId: a.id }]
                            },
                            limit: 1
                        }
                    }).$promise.then((cursos) => {
                        if (cursos.length > 0) {
                            status.push({
                                error: true,
                                areaInteresseId: a.id,
                                message: `Não é possível eliminar a área de interesse ${a.designacao}: Existem cursos com esta área de interesse.`
                            });
                            deferDelete.resolve(a.id);
                        }
                        else { // No active cursos with area, safe to delete.
                            a.funcionarioId = this.Auth.getId();
                            a.dataEdicao = moment().format();
                            a.active = 0;
                            this.FormacaoAreaInteresse.upsert(a).$promise.then((res) => {
                                status.push({
                                    error: false,
                                    areaInteresseId: a.id
                                });
                                deferDelete.resolve(a.id);
                            }).catch((error) => {
                                console.log(error);
                                status.push({
                                    error: true,
                                    areaInteresseId: a.id,
                                    message: `Erro na eliminação de testemunho ${a.id}`
                                });
                                deferDelete.resolve(a.id);
                            });
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                    tasks.push(deferDelete.promise);
                });
                this.$q.all(tasks).then((res) => {
                    defer.resolve(status);
                }).catch(error => {
                    defer.reject(error);
                });
            }
            else { // Return error saying not all was found
                status.push({
                    error: true,
                    message: 'Não foi possível encontrar todas as áreas para eliminar. Recarregue a página e verifique se ainda existem.'
                });
                defer.resolve(status);
            }
        }).catch((error) => {
            defer.reject(error);
        });
        return defer.promise;
    };
    // Checks if exists Slug anywhere. If id is provided find elsewhere (because it might exist here)
    checkExistingSlug = (slug, id) => {
        let defer = this.$q.defer();
        let where = {
            and: [{ active: 1 }, { slug: slug }]
        };
        if (id)
            where.and.push({ id: { neq: id } });
        this.FormacaoEdicao.find({
            filter: {
                where: where
            }
        }).$promise.then((res) => {
            if (res.length > 0) {
                defer.resolve(true); // Already exists
            }
            else {
                defer.resolve(false); // Does not exist
            }
        }).catch((error) => {
            defer.reject(error);
        });
        return defer.promise;
    };
}
FormacaoService.$inject = ['$q', 'UIService', 'AuthenticationService', 'FormacaoTestemunho', 'FormacaoAreaInteresse', 'FormacaoCurso', 'FormacaoEdicao'];
